import { computed } from 'vue';
import { useStore } from 'vuex';
import { cookie } from '@/helpers';
import { SELECTED_REGION_GET } from '@/store/homeContent/types';

export default () => {
  function isLocationSet() {
    const str = cookie.getCookie('location');
    return (!!str);
  }

  function getCurrentLocation() {
    const str = cookie.getCookie('location');

    const parts = decodeURI(decodeURI(str)).split('!');
    let lat = null;
    let lon = null;
    if (parts[0]) {
      lat = parseFloat(parts[0]);
    }
    if (parts[1]) {
      lon = parseFloat(parts[1]);
    }

    return {
      lat,
      lon,
    };
  }
  // Function for async get location from navigation ( wating until geoloc set)
  async function getAsyncLocation() {
    const str = cookie.getCookie('location');
    if (!str) {
      await new Promise((resolve) => {
        window.addEventListener('cookie_location::ready', async () => {
          resolve(true);
        }, { once: true });
      });
      return getCurrentLocation();
    }
    return getCurrentLocation();
  }
  function getRegionTid() {
    const str = cookie.getCookie('region_tid');
    if (!str) return {};
    try {
      const regionCookie = JSON.parse(decodeURIComponent(str));
      return { region_id: (regionCookie.user_selected !== null) ? regionCookie.user_selected : regionCookie.detected };
    } catch (e) {
      console.log(e);
      return {};
    }
  }

  function setRegionTid(region) {
    if (region?.tid && region.field_iso_code) {
      cookie.setCookie('region_tid', encodeURIComponent(JSON.stringify({ user_selected: region.tid, region_iso: region.field_iso_code })));
    }
  }
  const store = useStore();
  const currentSelectedRegionTid = computed(() => store.getters[SELECTED_REGION_GET]);
  return {
    isLocationSet,
    getCurrentLocation,
    getAsyncLocation,
    getRegionTid,
    setRegionTid,
    currentSelectedRegionTid,
  };
};
